export default class Youtube {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.videoContainer = this.element.querySelector('.js-youtube');
    this.poster = this.element.querySelector('.js-poster');
    this.videoId = this.element.dataset.videoId;
    this.autoplay = this.poster ? 1 : 0;
    this.playerReady = false;

    Youtube.instances.push(this);

    if (this.videoId) {
      Youtube.loadScript(); //si il existe une video avec un ID, appeler la méthode pour charger le script
    } else {
    }
  }
  /**
   * charge le script si ce n'est pas déjà fait
   */
  static loadScript() {
    if (!Youtube.scriptIsLoading) {
      //si le script n'a pas déjà chargé
      Youtube.scriptIsLoading = true;
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(script);
    }
  }

  init() {
    this.initPlayer = this.initPlayer.bind(this);
    if (this.poster) {
      this.element.addEventListener('click', this.initPlayer.bind(this)); //si un poster existe, lui attribue un click pour pouvoir partir la video
    } else {
      this.initPlayer(); //sinon juste partir la video
    }
  }

  initPlayer(event) {
    if (event) {
      this.element.removeEventListener('click', this.initPlayer); //dès que le poster est cliqué, enlève le click
    }

    this.player = new YT.Player(this.videoContainer, {
      //initie la vidéo seloin le script
      height: '100%',
      width: '100%',
      videoId: this.videoId,
      playerVars: { rel: 0, autoplay: this.autoplay, controls: 0 },
      events: {
        onReady: () => {
          this.playerReady = true; //la vidéo est prête à jouer
          const observer = new IntersectionObserver(this.watch.bind(this), {
            rootMargin: '0px 0px 0px 0px',
          });
          observer.observe(this.element);
        },
        onStateChange: (event) => {
          if (event.data == YT.PlayerState.PLAYING) {
            Youtube.pauseAll(this); //pause toutes les vidéos sauf celui qui joue
          } else if (event.data == YT.PlayerState.ENDED) {
            //si la video finit, amene la video au début et là pause
            this.player.seekTo(0);
            this.player.pauseVideo();
          }
        },
      },
    });
  }

  /**
   * si la video est prête et quelle sort de la page, l'arrête
   * @param {type} entries- les entrées à surveiller
   */

  watch(entries) {
    if (this.playerReady && !entries[0].isIntersecting) {
      this.player.pauseVideo();
    }
  }

  static initAll() {
    document.documentElement.classList.add('is-video-ready');
    for (let i = 0; i < Youtube.instances.length; i++) {
      const instance = Youtube.instances[i];
      instance.init(); //pour chaque vidéo, appelle la fonction init
    }
  }

  /**
   * mets sur pause toutes les vidéos qui ne sont pas la cible
   * @param {type} currentInstance - la vidéo que l'on cible
   */

  static pauseAll(currentInstance) {
    for (let i = 0; i < Youtube.instances.length; i++) {
      const instance = Youtube.instances[i];
      if (instance.playerReady && instance !== currentInstance) {
        //si la vidéo est prête et que ce n'est pas celle que l'on cible, la mets en pause
        instance.player.pauseVideo();
      }
    }
  }
}

Youtube.instances = []; //contient toutes les vidéos présentes sur le site
window.onYouTubeIframeAPIReady = Youtube.initAll; //re-localise la fonction de la préparation du script à fonctionner
